export const SET_PROFILE = 'setProfile';
export const SET_ACCESS_TOKEN = 'setAccessToken';
export const SET_ID_TOKEN = 'setIdToken';
export const SET_VERIFICATION = 'setVerification';
export const SET_AUTHENTICATED = 'setAuthenticated';
export const SET_GROUPS = 'setGroups';
export const SET_COGNITO_IDENTITY_ID = 'setCognitoIdentityId';
export const SET_COGNITO_IDENTITY_ROLE = 'setCognitoIdentityRole';
export const CLEAR_COGNITO_IDENTITY_ROLES = 'clearCognitoIdentityRoles';



// WEBPACK FOOTER //
// ./src/store/auth/auth.mutations.js